var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-tooltip d-flex"},[_vm._t("default"),_c('el-tooltip',{attrs:{"effect":_vm.theme,"content":_vm.label,"placement":_vm.placement}},[_vm._t("trigger",[_c('sup',[_vm._v("?")])])],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }